/**
 * Higiene Oral Simplificada (H.O.S.) — indicador MSP / historia clínica Ecuador.
 * Seis registros con piezas índice FDI (permanentes y temporales en la misma fila).
 */

export const HOS_FILAS_PIEZAS_DEFAULT = [
  [16, 17, 55],
  [11, 21, 51],
  [26, 27, 65],
  [36, 37, 75],
  [31, 41, 71],
  [46, 47, 85],
];

export function createHosFila(piezas = [null, null, null]) {
  return {
    piezas: piezas.map((p) => (p != null ? Number(p) : null)),
    marcas: ['', '', ''],
    placa: '',
    calculo: '',
    gingivitis: '',
  };
}

export function createDefaultHigieneOralSimplificada() {
  return {
    filas: HOS_FILAS_PIEZAS_DEFAULT.map((piezas) => createHosFila(piezas)),
  };
}

function parseScore(val, max) {
  if (val === '' || val === null || val === undefined) return null;
  const n = Number(val);
  if (!Number.isFinite(n) || n < 0 || n > max) return null;
  return n;
}

/** Suma de valores ingresados por columna (celdas naranja «TOTALES»). */
export function calcularHosTotales(filas = []) {
  const sum = { placa: 0, calculo: 0, gingivitis: 0 };
  const count = { placa: 0, calculo: 0, gingivitis: 0 };

  filas.forEach((fila) => {
    const p = parseScore(fila.placa, 3);
    const c = parseScore(fila.calculo, 3);
    const g = parseScore(fila.gingivitis, 1);
    if (p !== null) { sum.placa += p; count.placa += 1; }
    if (c !== null) { sum.calculo += c; count.calculo += 1; }
    if (g !== null) { sum.gingivitis += g; count.gingivitis += 1; }
  });

  return {
    placa: count.placa ? sum.placa : '',
    calculo: count.calculo ? sum.calculo : '',
    gingivitis: count.gingivitis ? sum.gingivitis : '',
    promedioPlaca: count.placa ? (sum.placa / count.placa).toFixed(2) : '',
    promedioCalculo: count.calculo ? (sum.calculo / count.calculo).toFixed(2) : '',
    promedioGingivitis: count.gingivitis ? (sum.gingivitis / count.gingivitis).toFixed(2) : '',
  };
}

/** Normaliza datos guardados o migra desde campos legacy (placa/cálculo/gingivitis únicos). */
export function normalizeHigieneOralSimplificada(paciente = {}) {
  const raw = paciente.higieneOralSimplificada;
  if (raw && Array.isArray(raw.filas) && raw.filas.length > 0) {
    const defaults = createDefaultHigieneOralSimplificada().filas;
    return {
      filas: defaults.map((def, i) => {
        const saved = raw.filas[i] || {};
        return {
          piezas: Array.isArray(saved.piezas) && saved.piezas.length === 3
            ? saved.piezas.map((p) => (p != null && p !== '' ? Number(p) : null))
            : def.piezas,
          marcas: Array.isArray(saved.marcas) && saved.marcas.length === 3
            ? saved.marcas.map((m) => (m ? String(m) : ''))
            : ['', '', ''],
          placa: saved.placa != null ? String(saved.placa) : '',
          calculo: saved.calculo != null ? String(saved.calculo) : '',
          gingivitis: saved.gingivitis != null ? String(saved.gingivitis) : '',
        };
      }),
    };
  }
  return createDefaultHigieneOralSimplificada();
}

/** Sincroniza campos legacy de la ficha para informes que aún lean placa/cálculo/gingivitis globales. */
export function syncHosLegacyFields(higieneOralSimplificada) {
  const tot = calcularHosTotales(higieneOralSimplificada?.filas || []);
  return {
    placa: tot.promedioPlaca !== '' ? tot.promedioPlaca : '',
    calculo: tot.promedioCalculo !== '' ? tot.promedioCalculo : '',
    gingivitis: tot.promedioGingivitis !== '' ? tot.promedioGingivitis : '',
  };
}

export function formatHosValorDisplay(val, max) {
  if (val === '' || val === null || val === undefined) return '—';
  const n = Number(val);
  if (!Number.isFinite(n)) return String(val);
  return `${n} / ${max}`;
}
